<template>
  <div class="carouselWrap">
    <el-carousel indicator-position="none" :interval="2000" trigger="click" v-if="getLanguage == 'zh'">
      <el-carousel-item v-for="(item, index) in guideBannersCn" :key="index">
        <img :src="item.url" alt="" />
      </el-carousel-item>
    </el-carousel>
    <el-carousel indicator-position="none" :interval="2000" trigger="click" v-else>
      <el-carousel-item v-for="(item, index) in guideBanners" :key="index">
        <img :src="item.url" alt="" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getAction } from "@/api/common";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      guideBanners: [], // 滚动banner
      guideBannersCn: [], // 滚动banner
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    // 获取新手指导链接
    getBeginnerGuideLink() {
      getAction("/stCustomPage/detail", {})
        .then(res => {
          const resData = res.data || {};
          this.$emit("setToLink", resData);
          this.setBannerList(resData);
        })
        .catch(err => {});
    },
    // 设置banner图列表
    setBannerList(data) {
      if (data.guideBanners && data.guideBanners.length == 2) {
        // 解决el-carousel两张图片不能朝同一个方向滚动的bug
        this.guideBanners = [...data.guideBanners, ...data.guideBanners];
      } else {
        this.guideBanners = data.guideBanners || [];
      }
      if (data.guideBannersCn && data.guideBannersCn.length == 2) {
        // 解决el-carousel两张图片不能朝同一个方向滚动的bug
        this.guideBannersCn = [...data.guideBannersCn, ...data.guideBannersCn];
      } else {
        this.guideBannersCn = data.guideBannersCn || [];
      }
    },
  },
  created() {
    // 获取新手指导链接、banner
    this.getBeginnerGuideLink();
  },
};
</script>

<style lang="scss" scoped>
.carouselWrap {
  width: 100%;
  height: 100%;

  ::v-deep {
    .el-carousel {
      width: 100%;
      height: 100%;
    }

    .el-carousel__container {
      width: 100%;
      height: 100%;
    }

    .el-carousel__item {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
